import styled from "styled-components";
import ClearIcon from '@mui/icons-material/Clear';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AceEditor from "react-ace";
import RefreshIcon from '@mui/icons-material/Refresh';

export const ComponentBaseContainer = styled.div`
  height: 90vh;
  display: flex;
  color: white;
  align-items: center;
  margin: 10px;
  padding: 10px;
`;

export const ComponentContainer = styled.div`
  display: flex;
  width: 100%;
  background: white;
  height: 100%;
  margin-top: 5%;
  margin-left: 20px;
  border-radius: 10px;
`;

export const JsonContainer = styled.div`
  width: 50%;
  margin: 10px;
  background: white;
  display: flex;
  flex-direction:column;
  box-shadow: 0 8px 24px rgba(255, 255, 255, 0.05),
              0 2px 6px rgba(0, 0, 0, 0.2);
`;

export const JsonTextContainer = styled(AceEditor)`
  border: none;
  outline: none;
  width: 100% !important;
  height: 100% !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  flex: 1; 
  box-sizing: border-box;
`;

export const JsonHelperContainer = styled.div`
    display: flex;
    justify-content: right;
    align-items: center;
    color: black;
`;

export const StyledClearIcon = styled(ClearIcon)`
 color: black;
 align-self: end;
  cursor: pointer;
    margin:2px;
  &:active {
    transform: scale(0.9);
  }
`;

export const StyledCopyIcon = styled(ContentCopyIcon)`
  cursor: pointer;
  margin:2px;
  &:active {
    transform: scale(0.9);
  }
`;
export const StyledRefreshIcon = styled(RefreshIcon)`
  cursor: pointer;
  margin:2px;
  &:active {
    transform: scale(0.9);
  }
`;

export const Toast = styled.div`
    position: absolute;
    top: 10px;
    left: 50%";
    transform: translateX(-50%);
    background: #323232;
    color: white;
    padding: 8px 16px;
    borderRadius: 6px;
    opacity: 0.9;
    fontSize: 14px; 
`;